import headScripts from 'client/signup/headScripts/headScripts';

const generateGoogleTagManager = (page) => ({
  data() {
    return {
      googleTagManagerScript: headScripts.googleTagManager(page),
    };
  },
});

const title = (page) => ({
  data() {
    return {
      title: `${page} | JumpCloud`,
    };
  },
});

export default { generateGoogleTagManager, title };
